import { render } from "./ProposalGeneralSubjectsList.vue?vue&type=template&id=fdee266e"
import script from "./ProposalGeneralSubjectsList.vue?vue&type=script&lang=js"
export * from "./ProposalGeneralSubjectsList.vue?vue&type=script&lang=js"

import "./ProposalGeneralSubjectsList.vue?vue&type=style&index=0&id=fdee266e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__